(function () {
  "use strict";

  if (window.customElements.get("media-carousel")) {
    enhanceMediaCarousel();
  } else {
    document.addEventListener("DOMContentLoaded", function () {
      setTimeout(enhanceMediaCarousel, 100);
    });
  }

  function enhanceMediaCarousel() {
    const MediaCarouselPrototype =
      window.customElements.get("media-carousel").prototype;

    const originalOnGalleryClick = MediaCarouselPrototype._onGalleryClick;

    MediaCarouselPrototype._onGalleryClick = function (event) {
      if (
        event.target.matches("button, a[href], button :scope, a[href] :scope")
      ) {
        return;
      }

      const productGallery = this.closest("product-gallery");
      if (productGallery && productGallery.hasAttribute("allow-zoom")) {
        const clickedMedia = event.target.closest(".product-gallery__media");
        if (
          clickedMedia &&
          clickedMedia.getAttribute("data-media-type") === "image"
        ) {
          const visibleImages = this.visibleItems.filter(
            (item) => item.getAttribute("data-media-type") === "image"
          );
          const clickedIndex = visibleImages.indexOf(clickedMedia);

          this.dispatchEvent(
            new CustomEvent("lightbox:open", {
              bubbles: true,
              detail: { index: clickedIndex },
            })
          );
          return;
        }
      }

      if (!window.matchMedia("screen and (pointer: fine)").matches) {
        return;
      }

      if (this.selectedSlide.getAttribute("data-media-type") !== "image") {
        return;
      }

      const rect = event.currentTarget.getBoundingClientRect(),
        offsetX = event.clientX - rect.left;
      offsetX > this.clientWidth / 2 ? this.next() : this.previous();
    };
  }
})();
